<template>
  <div
    class="tw-bg-white tw-z-10 tw-text-center tw-pt-4 tw-space-y-4 tw-flex tw-flex-col tw-border-r"
  >
    <div
      class="tw-flex-none tw-flex tw-h-8 tw-px-2 tw-justify-between tw-items-center tw-gap-2"
    >
      <div class="tw-relative search tw-w-full tw-h-full">
        <input
          class="tw-flex tw-w-full tw-h-8 tw-px-2 tw-pl-8 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-text-slate-600"
          type="text"
          placeholder="Search..."
          v-model.trim="filterInput"
        />
        <svg
          class="filter-icom tw-flex tw-absolute tw-w-4 tw-h-4 tw-top-2 tw-left-2 tw-fill-slate-300"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"
          />
        </svg>
      </div>
      <RoomFilter v-model="filterCheckbox" />
      <button
        class="create-btn tw-rounded-full hover:tw-bg-slate-200"
        @click="createRoomDialog = true"
      >
        <svg
          class="tw-w-6 tw-h-6 tw-fill-green-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"
          />
        </svg>
      </button>
    </div>
    <div
      class="tw-flex-none tw-flex tw-justify-center tw-gap-2 tw-text-sm tw-text-center tw-m-2"
    >
      <button
        v-if="canAccessAllRoom"
        @click="roomMode = 'all'"
        class="tw-flex tw-items-center tw-justify-center tw-px-2 tw-w-36 tw-py-2 tw-rounded-lg"
        :class="getBtnBG('all')"
      >
        <div>All ({{ totalRooms }})</div>
        <!-- <div v-else class="">All ({{ localRooms.length }})</div> -->
      </button>
      <button
        @click="roomMode = 'assigned'"
        class="tw-flex tw-items-center tw-justify-center tw-px-2 tw-w-36 tw-py-1 tw-rounded-lg"
        :class="getBtnBG('assigned')"
      >
        <div v-if="agentRoomsToken">My rooms (100+)</div>
        <div v-else class="">My rooms ({{ localAgentRooms.length }})</div>
      </button>
    </div>
    <div
      @scroll.passive="handleScroll"
      class="rooms tw-flex-auto tw-flex tw-flex-col tw-w-full tw-overflow-scroll"
    >
      <RoomCard
        ref="roomCard"
        v-for="room in filteredRoom"
        :key="room.RoomID"
        :roomProps="room"
        @click-room="onClickRoom(room)"
        :selected="selectedRoomID === room.RoomID"
        :socket="consoleSocket"
      ></RoomCard>
      <div
        v-if="loading"
        class="loading-indicator tw-flex tw-justify-center tw-w-full tw-h-min"
      >
        <svg
          role="status"
          class="tw-mt-4 tw-w-8 tw-self-center tw-h-8 tw-mr-2 tw-text-gray-200 tw-animate-spin tw-dark:text-gray-600 tw-fill-primary"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
      </div>
      <div
        v-else-if="!roomsToken"
        class="tw-w-full tw-text-center tw-text-gray-400"
      >
        No more
      </div>
    </div>
    <ModalDialog v-model="createRoomDialog" title="Creator Room">
      <form class="tw-text-left tw-p-2" @submit.prevent="onCreateRoom">
        <div class="tw-mb-4">
          <label
            for="name"
            class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300"
            >Guest name *</label
          >
          <input
            type="text"
            id="name"
            class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-sm tw-rounded-lg focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-700 dark:tw-border-gray-600 dark:tw-placeholder-gray-400 dark:tw-text-white dark:focus:tw-ring-blue-500 dark:focus:tw-border-blue-500"
            placeholder="guest name"
            required
            v-model.trim="createRoomFormData.name"
          />
        </div>
        <div class="tw-mb-4">
          <label
            for="phone"
            class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300"
            >Phone number</label
          >
          <input
            type="text"
            id="phone"
            class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-sm tw-rounded-lg focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-700 dark:tw-border-gray-600 dark:tw-placeholder-gray-400 dark:tw-text-white dark:focus:tw-ring-blue-500 dark:focus:tw-border-blue-500"
            placeholder="061-2345678"
            v-model.trim="createRoomFormData.phone"
          />
        </div>
        <div class="tw-mb-4">
          <label
            for="email"
            class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300"
            >Email</label
          >
          <input
            type="text"
            id="email"
            class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-sm tw-rounded-lg focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-700 dark:tw-border-gray-600 dark:tw-placeholder-gray-400 dark:tw-text-white dark:focus:tw-ring-blue-500 dark:focus:tw-border-blue-500"
            placeholder="guest@villa.com"
            v-model.trim="createRoomFormData.email"
          />
        </div>

        <div class="tw-flex tw-justify-end">
          <button
            type="submit"
            class="tw-text-white tw-bg-primary hover:tw-bg-primary-light tw-px-4 tw-py-1 tw-rounded-lg"
          >
            Submit
          </button>
        </div>
      </form>
    </ModalDialog>
    <audio ref="audioElm" :src="audio"></audio>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Auth from "@aws-amplify/auth";
import dayjs from "dayjs";
import short from "short-uuid";
import debounce from "debounce";
import { EventBus } from "@/event-bus";
// import RoomCardTag from "./RoomCardTag.vue";

// let audio = new Audio(require("@/assets/sound/new-message.mp3"));

export default {
  name: "ChatConsole",
  components: {
    RoomCard: () => import("./RoomCard.vue"),
    ModalDialog: () => import("@/ui/components/chat/ModalDialog.vue"),
    RoomFilter: () => import("@/ui/components/chat/RoomFilter.vue"),
  },
  data() {
    return {
      totalRooms: 0,
      loading: true,
      roomMode: "all",
      filterInput: null,
      filterCheckbox: {
        tags: [],
        status: [],
      },
      consoleSocket: null,
      pingInterval: null,
      search: [],
      localRooms: [],
      localAgentRooms: [],
      roomsToken: null,
      agentRoomsToken: null,
      createRoomDialog: false,
      // roomsByTagStatusFilter: [],
      createRoomFormData: {
        name: "",
        phone: "",
        email: "",
      },
      audio: require("@/assets/sound/new-message.mp3"),
    };
  },
  computed: {
    ...mapGetters({
      rooms: "chat/rooms",
      channel: "chat/channel",
      selectedRoomID: "chat/selectedRoomID",
      user: "chat/user",
      decoded: "chat/decoded",
      tags: "chat/tags",
      myAgentInfo: "chat/myAgentInfo",
      canPushNotification: "chat/canPushNotification",
    }),
    canAccessAllRoom() {
      return (
        this.myAgentInfo?.Role === "Admin" ||
        this.myAgentInfo?.Role === "Service"
      );
    },
    userID() {
      return this.decoded["cognito:username"] || null;
    },
    isSearching() {
      return [null, undefined, ""].indexOf(this.filterInput) < 0;
    },
    filteredRoom() {
      if (this.isSearching) {
        return this.search;
      }
      let rooms =
        this.roomMode === "assigned" ? this.localAgentRooms : this.localRooms;
      rooms = rooms.filter((room) => {
        // filter room information
        if (!room.RoomID) return false;
        if (!room.CreatorID) return false;

        if (
          this.filterCheckbox.tags.length > 0 &&
          this.filterCheckbox.status.length > 0
        ) {
          // both tag and status
          const roomTags = [
            ...room.IssueTags,
            ...room.CustomerTags,
            ...room.OrderTags,
          ];

          const tagIndex = this.filterCheckbox.tags.findIndex((t) => {
            return (
              roomTags.findIndex(
                (rt) => rt.Type === t.Type && rt.Title === t.Title
              ) !== -1
            );
          });
          const statusIndex = this.filterCheckbox.status.findIndex(
            (s) => s === room.Status
          );
          return tagIndex >= 0 && statusIndex >= 0;
        }
        if (this.filterCheckbox.tags.length > 0) {
          // only tag
          const roomTags = [
            ...room.IssueTags,
            ...room.CustomerTags,
            ...room.OrderTags,
          ];

          const tagIndex = this.filterCheckbox.tags.findIndex((t) => {
            return (
              roomTags.findIndex(
                (rt) => rt.Type === t.Type && rt.Title === t.Title
              ) !== -1
            );
          });
          return tagIndex >= 0;
        }
        // only status
        if (this.filterCheckbox.status.length > 0) {
          const statusIndex = this.filterCheckbox.status.findIndex(
            (s) => s === room.Status
          );
          return statusIndex >= 0;
        }
        return true;
      });
      return rooms || [];
    },
  },

  // async beforeCreate() {
  //   //Get user info
  //   const user = await Auth.currentUserInfo();
  //   await this.$store.commit("chat/setUser", user);
  //   const decoded = await this.$store.dispatch("chat/getDecodedUser");
  //   console.log(decoded);
  //   this.$store.commit("chat/setDecoded", decoded);

  //   await this.$store.dispatch(
  //     "chat/getAgentByAgentID",
  //     decoded["cognito:username"]
  //   );
  // },

  async created() {
    //Get user info
    const user = await Auth.currentUserInfo();
    await this.$store.commit("chat/setUser", user);
    const decoded = await this.$store.dispatch("chat/getDecodedUser");
    console.log("chat console created", decoded);
    this.$store.commit("chat/setDecoded", decoded);

    const agentInfo = await this.$store.dispatch(
      "chat/getAgentByAgentID",
      decoded["cognito:username"]
    );

    if (agentInfo.Role === "Admin" || agentInfo.Role === "Service") {
      this.roomMode = "all";
    } else {
      this.roomMode = "assigned";
    }

    //Connect to console socket
    console.log("before connect web socket", this.user);
    await this.connectWebSocket();
  },

  async mounted() {
    EventBus.$on("new-room-alert", async () => {
      this.totalRooms = await this.$store.dispatch("chat/getTotalCreatedRoom");
      this.play();
    });
    EventBus.$on("update-local-room-status", (data) => {
      console.log("update-local-room-status", data);
      this.updateRoomStatus(data.roomID, data.status);
    });
    EventBus.$on("update-local-tags", (room) => {
      console.log("update-local-tags", room);
      const roomID = room.RoomID;

      // All rooms
      const allIdx = this.localRooms.findIndex(
        (room) => room.RoomID === roomID
      );
      if (allIdx >= 0) {
        let allRooms = this.localRooms;
        allRooms[allIdx] = room;
        this.localRooms = JSON.parse(JSON.stringify(allRooms));
      }

      // Assigned room
      const assignedIdx = this.localAgentRooms.findIndex(
        (room) => room.RoomID === roomID
      );
      if (assignedIdx >= 0) {
        let assignedRooms = this.localAgentRooms;
        assignedRooms[assignedIdx] = room;
        this.localAgentRooms = JSON.parse(JSON.stringify(assignedRooms));
      }
    });

    //Get all tags
    await this.$store.dispatch("chat/listTags");

    // Manual close socket
    // setTimeout(() => {
    //   console.log("close socket");
    //   this.consoleSocket.close();
    // }, 1000 * 10);

    this.loading = true;
    //Get rooms list
    this.totalRooms = await this.$store.dispatch("chat/getTotalCreatedRoom");
    this.totalRoomsInterval = setInterval(async () => {
      this.totalRooms = await this.$store.dispatch("chat/getTotalCreatedRoom");
    }, 1000 * 60);

    await this.getRooms();
    //Get agent assigned room
    await this.getAgentRooms();
    this.sortRooms();
    this.loading = false;
  },
  watch: {
    consoleSocket: {
      immediate: true,
      handler: function (value) {
        this.$store.commit("chat/setConsoleSocket", value);
      },
      deep: true,
    },
    rooms: {
      immediate: false,
      handler: async function () {
        await this.$store.dispatch("chat/getRoomsByAgentID", {
          lastest: false,
        });
      },
      // deep: true,
    },
    filterInput: {
      immediate: false,
      handler: async function (val) {
        if (!val) return;
        this.loading = true;
        await this.searchRoom(val);
        this.loading = false;
      },
    },
  },

  methods: {
    play() {
      this.$refs.audioElm.play();
    },
    updateRoomStatus(roomID, newStatus) {
      const allRooms = this.localRooms;
      const allIdx = allRooms.findIndex((room) => room.RoomID === roomID);
      if (allIdx >= 0) {
        allRooms[allIdx].Status = newStatus;
      }
      const assignedRooms = this.localAgentRooms;
      const assignedIdx = assignedRooms.findIndex(
        (room) => room.RoomID === roomID
      );
      if (assignedIdx >= 0) {
        assignedRooms[assignedIdx].Status = newStatus;
      }
      this.localRooms = JSON.parse(JSON.stringify(allRooms));
      this.localAgentRooms = JSON.parse(JSON.stringify(assignedRooms));
      console.log("updateRoomStatus", allIdx, assignedIdx);
    },
    getBtnBG(mode) {
      if (mode === this.roomMode) return "tw-bg-slate-500 tw-text-white";
    },
    searchRoom: debounce(async function (keyword) {
      this.search = [];
      const search = await this.$store.dispatch("chat/searchRooms", {
        keyword: keyword,
      });
      console.log("search", search);
      this.search = search;
    }, 500),
    async authorizeConsoleSocket() {
      const TOKEN = await this.$store.dispatch("chat/getJwt");

      // Agent authorize message body
      const body = {
        action: "authorize",
        token: TOKEN,
        type: "Console",
        isCustomer: false,
        checkExists: true,
        name: this.user.username,
        role: "Employee",
        branch: this.user?.attributes["custom:branch"],
      };

      // Send authorize message
      this.consoleSocket.send(JSON.stringify(body));

      // Set ping interval
      if (!this.pingInterval) {
        this.pingInterval = setInterval(() => {
          console.log("send ping");
          const body = {
            action: "ping",
            token: TOKEN,
          };
          this.consoleSocket.send(JSON.stringify(body));
        }, 1000 * 60 * 5);
      }
      console.log("console socket has been authorized.");
    },
    async connectWebSocket() {
      // const URL =
      //   "wss://6ek73q3k35.execute-api.ap-southeast-1.amazonaws.com/dev";
      const URL =
        "wss://n030cqcuu2.execute-api.ap-southeast-1.amazonaws.com/production";

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let me = this;
      const socket = new WebSocket(URL);
      this.consoleSocket = socket;
      this.consoleSocket.addEventListener("open", async function (event) {
        console.log(event);
        console.log("Socket connected");
        await me.authorizeConsoleSocket();
      });

      this.consoleSocket.addEventListener("close", function (event) {
        console.log(event);
        // window.alert("Chat has been disconnected.");
        console.log("Socket closed, reconnect in 10 second");
        clearInterval(me.pingInterval);
        setTimeout(async () => {
          await me.connectWebSocket();
        }, 1000 * 10);
      });

      this.consoleSocket.addEventListener("message", async function (event) {
        const message = JSON.parse(event.data);
        console.log("Message in console socket", message);
        //update room card last message
        if (message.Type === "text" || message.Type === "image") {
          me.handlerMessage(message);
        } else if (message.Type === "agent-assigned-notification") {
          await me.updateRoom(message.RoomID);
        }
      });
    },
    async updateRoom(roomID) {
      console.log("Get room by updateRoom");
      const roomResponse = await this.$store.dispatch("chat/getRoom", roomID);

      const allIdx = this.localRooms.findIndex(
        (room) => room.RoomID === roomID
      );
      if (allIdx >= 0) {
        this.localRooms[allIdx] = roomResponse;
      } else {
        this.localRooms.push(roomResponse);
      }

      const assignedIdx = this.localAgentRooms.findIndex(
        (room) => room.RoomID === roomID
      );
      if (assignedIdx >= 0) {
        this.localAgentRooms[assignedIdx] = roomResponse;
      } else {
        // Check room participant
        const mainParticipants = roomResponse.MainChannel?.Participants || [];
        if (mainParticipants.findIndex((p) => p.ID === this.userID) >= 0) {
          this.localAgentRooms.push(roomResponse);
        }
      }

      this.sortRooms();
    },
    updateRoomLastMessage(room, message) {
      console.log("updateRoomLastMessage", message);
      if (message.Channel === "main") {
        const currentLastMainMessage = room.MainChannel.LastMessage;
        if (
          dayjs(currentLastMainMessage.CreatedAt) <= dayjs(message.CreatedAt)
        ) {
          console.log("update new main message", message);
          room.MainChannel.LastMessage = message;
          if (!message.Silence) {
            room.UpdatedAt = message.UpdatedAt;
          }
        }
      } else if (message.Channel === "background") {
        const currentLastBackgroundMessage = room.MainChannel.LastMessage;
        if (
          dayjs(currentLastBackgroundMessage.CreatedAt) <=
          dayjs(message.CreatedAt)
        ) {
          console.log("update new background message");
          room.BackgroundChannel.LastMessage = message;
          if (!message.Silence) {
            room.UpdatedAt = message.UpdatedAt;
          }
        }
      }
    },
    pushNotification(title, message) {
      console.log("pushNotification", title, message);
      if (this.canPushNotification && Notification.permission === "granted") {
        const notification = new Notification(title, {
          body: message,
          icon: "https://shop.villamarket.com/img/logo-villa-mobile.349b5202.svg",
        });
        notification.onclick = (e) => {
          console.log("onclick notification", e);
        };
      }
    },
    async handlerMessage(message) {
      console.log("handlerMessage", message);
      if (message.Silence) {
        // Skip
      } else {
        if (message.SenderID !== this.userID) {
          let text;
          switch (message.Type) {
            case "text":
              text = message.Text;
              break;
            case "image":
              text = "Image";
              break;
            default:
              break;
          }
          EventBus.$emit("new-socket-message", {
            message: message,
            callback: () => {
              this.pushNotification("New message", text);
              this.play();
            },
          });
        }
      }

      let _getRoomResponse = null;

      // update last message in all room
      const roomIndex = this.localRooms.findIndex(
        (room) => room.RoomID === message.RoomID
      );
      if (roomIndex !== -1) {
        // have room in rooms list
        console.log("handlerMessage: have room in rooms list");
        this.updateRoomLastMessage(this.localRooms[roomIndex], message);
      } else {
        // have no room in rooms list, get room and push
        console.log("Get room by handlerMessage");
        const room = await this.$store.dispatch("chat/getRoom", message.RoomID);
        _getRoomResponse = room;
        // console.log("no room in rooms list, get new room", message.RoomID);
        console.log(
          "no room in rooms list, get new room",
          room,
          this.localRooms
        );
        const tempAllIndex = this.localRooms.findIndex(
          (room) => room.RoomID === message.RoomID
        );
        if (tempAllIndex === -1) {
          this.localRooms.push(room);
        }
      }

      // update agent assigned room
      const agentRoomIndex = this.localAgentRooms.findIndex(
        (room) => room.RoomID === message.RoomID
      );
      if (agentRoomIndex !== -1) {
        // have room in rooms list
        console.log("handlerMessage: have room in rooms list");
        this.updateRoomLastMessage(
          this.localAgentRooms[agentRoomIndex],
          message
        );
      } else {
        // have no room in rooms list, get room and push
        if (_getRoomResponse) {
          if (message.Channel === "main") {
            const mainParticipants =
              _getRoomResponse.MainChannel?.Participants || [];
            const isMainParticipant =
              mainParticipants.findIndex((p) => p.ID === this.userID) >= 0;

            if (isMainParticipant) {
              let tempAgentIndexMN = this.localRooms.findIndex(
                (room) => room.RoomID === message.RoomID
              );
              if (tempAgentIndexMN === -1) {
                this.localAgentRooms.push(_getRoomResponse);
              }
            }
          } else if (message.Channel === "background") {
            const backgroundParticipants =
              _getRoomResponse.BackgroundChannel?.Participants || [];
            const isBackgroundParticipant = backgroundParticipants.findIndex(
              (p) => p.ID === this.userID
            );

            if (isBackgroundParticipant) {
              let tempAgentIndexBG = this.localRooms.findIndex(
                (room) => room.RoomID === message.RoomID
              );
              if (tempAgentIndexBG === -1) {
                this.localAgentRooms.push(_getRoomResponse);
              }
              // this.localAgentRooms.push(_getRoomResponse);
            }
          }
        } else {
          console.log("Get room by handlerMessage2");
          const room = await this.$store.dispatch(
            "chat/getRoom",
            message.RoomID
          );
          console.log("no room in rooms list, get new room", room);
          if (message.Channel === "main") {
            const mainParticipants = room.MainChannel?.Participants || [];
            const isMainParticipant =
              mainParticipants.findIndex((p) => p.ID === this.userID) >= 0;

            if (isMainParticipant) {
              let tempAgentIndexMN = this.localAgentRooms.findIndex(
                (room) => room.RoomID === message.RoomID
              );
              if (tempAgentIndexMN === -1) {
                this.localAgentRooms.push(room);
              }
            }
          } else if (message.Channel === "background") {
            const backgroundParticipants =
              room.BackgroundChannel?.Participants || [];
            const isBackgroundParticipant = backgroundParticipants.findIndex(
              (p) => p.ID === this.userID
            );

            if (isBackgroundParticipant) {
              let tempAgentIndexBG = this.localAgentRooms.findIndex(
                (room) => room.RoomID === message.RoomID
              );
              if (tempAgentIndexBG === -1) {
                this.localAgentRooms.push(room);
              }
            }
          }
        }
      }
      this.sortRooms();
    },
    sortRooms() {
      this.localRooms.sort(
        (a, b) => dayjs(b.UpdatedAt).unix() - dayjs(a.UpdatedAt).unix()
      );
      this.localAgentRooms.sort(
        (a, b) => dayjs(b.UpdatedAt).unix() - dayjs(a.UpdatedAt).unix()
      );
    },

    onClickRoom(room) {
      if (this.selectedRoomID === room.RoomID) {
        return;
      }
      this.$store.commit("chat/setSelectedRoomID", room.RoomID);
    },

    handleScroll: debounce(function (event) {
      if (
        event.srcElement.scrollTop + event.srcElement.clientHeight >=
        event.srcElement.scrollHeight - 10
      ) {
        this.onLoadMore();
      }
    }, 100),

    async onLoadMore() {
      if (this.isSearching) return;
      if (this.roomMode === "all" && this.roomsToken) {
        this.loading = true;
        await this.getRooms();
      } else if (this.roomMode === "assigned" && this.agentRoomsToken) {
        this.loading = true;
        await this.getAgentRooms();
      }
      this.loading = false;
    },

    async getRooms() {
      const { list, nextToken } = await this.$store.dispatch("chat/listRooms", {
        type: "All",
        nextToken: this.roomsToken,
      });
      console.log("GetRoom", list, nextToken);
      const rooms = this.localRooms.map((room) => room.RoomID);
      const filteredList =
        list?.filter(
          (room) => rooms.findIndex((rid) => rid === room.RoomID) === -1
        ) || [];
      this.localRooms.push(...filteredList);
      this.roomsToken = nextToken;
      this.$store.commit("chat/setAllRooms", this.localRooms);
    },

    async getAgentRooms() {
      const { list, nextToken } = await this.$store.dispatch("chat/listRooms", {
        type: "Agent",
        agentID: this.decoded["cognito:username"],
        nextToken: this.agentRoomsToken,
      });
      console.log("GetRoom", list, nextToken);
      const rooms = this.localAgentRooms.map((room) => room.RoomID);
      const filteredList =
        list?.filter(
          (room) => rooms.findIndex((rid) => rid === room.RoomID) === -1
        ) || [];
      this.localAgentRooms.push(...filteredList);
      this.agentRoomsToken = nextToken;
      this.$store.commit("chat/setAssignedRooms", this.localAgentRooms);
    },
    async onCreateRoom() {
      console.log("onCreateRoom", this.createRoomFormData);
      const { name, phone, email } = this.createRoomFormData;

      // let name = prompt("Please enter customer name");
      if (name == null || name == "") {
        console.log("create room cancelled");
      } else {
        console.log("confirm create room");
        // Create room and assign me

        // const uid = short.uuid();
        const translator = short();
        const random = translator.new();

        let uid = "Guest-" + random;
        uid = uid.substring(0, 24);
        console.log(name, uid, uid.length);
        await this.$store.dispatch("chat/createRoom", {
          id: uid,
          name: name,
          phone: phone,
          email: email,
          agentID: this.decoded["cognito:username"],
          agentName: this.user.username,
        });
      }
      this.createRoomDialog = false;
    },
  },
  beforeDestroy() {
    console.log("disconnect WebSocket");
    clearInterval(this.pingInterval);
    this.consoleSocket.close();
    EventBus.$off("update-local-room-status");
    EventBus.$off("new-room-alert");
  },
};
</script>

<style scoped>

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.rooms::-webkit-scrollbar,
.message::-webkit-scrollbar,
.note-list::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}
.rooms::-webkit-scrollbar-thumb,
.message::-webkit-scrollbar-thumb,
.note-list::-webkit-scrollbar-thumb {
  max-height: 10%;
  border-radius: 10px;
  background: #cbd5e1;
}

</style>
